import request from '../axios';

export const sendCode = async (payload: ISendCodePayload) => {
  const {data} = await request.post(`/api/profile/new-send-code`, {
    ...payload,
  });

  return data;
};

export const sendConfirmation = async (
  payload: ISendConfirmationCodePayload,
) => {
  const {data}: {data: IAuthProfileResponse} = await request.post(
    `/api/profile/new-check-code`,
    {
      ...payload,
    },
  );
  return data;
};

export const signUp = async (payload: ISignUpPayload) => {
  const {data}: {data: IAuthProfileResponse} = await request.post(
    `/api/profile/register-profile`,
    {
      ...payload,
    },
  );
  return data;
};
